import { render, staticRenderFns } from "./DiscardTicket.vue?vue&type=template&id=3ca867ca&scoped=true"
import script from "./DiscardTicket.vue?vue&type=script&lang=js"
export * from "./DiscardTicket.vue?vue&type=script&lang=js"
import style0 from "./DiscardTicket.vue?vue&type=style&index=0&id=3ca867ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca867ca",
  null
  
)

export default component.exports